export default __webpack_public_path__ + "static/media/mysql.5bee7520.png";